"use strict";

var cg;

var ok_car_set={};


var def_sel_background = {
  background: '-webkit - linear - gradient(#890c09, # b2140d)',
  background: '-o - linear - gradient(#890c09, # b2140d)',
  background: '-moz-linear-gradient(#890c09, #b2140d)',
  background: 'linear-gradient(#890c09, #b2140d)'
}

var def_sel_borderbottom = {
  'border-bottom': '2px solid #a3110b'
}

var def_sel_input = {
  border: '1px solid #950e0a',
  color: '#950e0a'
}

var ok_sel_background;
var ok_sel_borderbottom;
var ok_sel_input;

export default {
  cg,
  ok_car_set,
  ok_sel_background,
  ok_sel_borderbottom,
  ok_sel_input
}
